import { z } from "zod";

import { assetSchema, levelSchema } from "../commons";

const myCreativeSchema = z.object({
  _id: z.string(),
  name: z.string(),
  level: levelSchema.optional(),
  avatar: z.string(),
  hero: assetSchema,
  website: z.string(),
  isAvailable: z.boolean(),
  isPortfolioActive: z.boolean(),
  specialties: z.array(z.string()),
});

export const getSummaryResponseSchema = z.object({
  myLists: z.number(),
  interviewing: z.number(),
  active: z.number(),
});

export type GetSummaryResponse = z.infer<typeof getSummaryResponseSchema>;

export const interviewingCreativeSchema = z.object({
  _id: z.string(),
  interviewsAt: z.array(z.union([z.string(), z.date()])),
  isCompleted: z.boolean(),
  designer: myCreativeSchema,
});

export type InterviewingCreative = z.infer<typeof interviewingCreativeSchema>;

export const getInterviewingResponseSchema = z.array(
  interviewingCreativeSchema,
);

export type GetInterviewingResponse = z.infer<
  typeof getInterviewingResponseSchema
>;

export const getRejectedResponseSchema = z.array(
  z.object({
    _id: z.string(),
    designer: myCreativeSchema,
  }),
);

export type GetRejectedResponse = z.infer<typeof getRejectedResponseSchema>;

export const activeCreativeSchema = z.object({
  _id: z.string(),
  startDate: z.union([z.date(), z.string()]).optional(),
  designer: z.object({
    _id: z.string(),
    name: z.string(),
    avatar: z.string(),
  }),
});

export type ActiveCreative = z.infer<typeof activeCreativeSchema>;

export const getActiveResponseSchema = z.array(activeCreativeSchema);

export type GetActiveResponse = z.infer<typeof getActiveResponseSchema>;
